function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.219 35.219",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030104"
    },
    d: "M17.612,0C11.005,0,5.647,5.321,5.647,11.885c0,3.358,3.295,9.374,3.295,9.374l8.229,13.96 l8.586-13.797c0,0,3.814-5.74,3.814-9.537C29.572,5.321,24.216,0,17.612,0z M17.555,18.431c-3.783,0-6.848-3.065-6.848-6.853 c0-3.783,3.064-6.846,6.848-6.846c3.781,0,6.851,3.063,6.851,6.846C24.406,15.366,21.336,18.431,17.555,18.431z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#030104"
    },
    points: "18.982,7.406 16.277,7.406 16.277,10.487 13.128,10.487 13.128,13.193 16.277,13.193  16.277,16.367 18.982,16.367 18.982,13.193 22.09,13.193 22.09,10.487 18.982,10.487  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.9244c8339a40b65f81d00d92cffb779a.svg";
export { ForwardRef as ReactComponent };